<script setup lang="ts">
import AppNavLink from "@/layout/AppNavLink.vue";
import { Link } from "@/stores/menu.ts";

defineProps<{
  links: Link[];
}>();
</script>

<template>
  <ul class="grid grid-cols-2 text-white gap-2.5 pt-2.5">
    <li v-for="link of links" :key="link.title">
      <app-nav-link v-bind="link">{{ link.title }}</app-nav-link>
    </li>
  </ul>
</template>
